/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Dashboard_Tokens_TitleInputs */



/**
* | output |
* | --- |
* | "Tokens" |
*
* @param {Partner_Dashboard_Tokens_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_dashboard_tokens_title = /** @type {((inputs?: Partner_Dashboard_Tokens_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Dashboard_Tokens_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Tokens")
	return /** @type {LocalizedString} */ ("Tokens")
});